import { type Store as StoreBase, storeCreate as storeCreateBase } from '@subaio/utils'
import { type ContainerState, ContainerStatus } from '@subaio/webapp/src/containers'

export type UserAuth =
	| {
			status: 'authenticated'
			token: string
			expiration: number
			userId: string
			brandId?: string
			userGroupId: string
	  }
	| { status: 'unauthenticated' }
	| { status: 'expired' }
export type UserAuthStatus = UserAuth['status']

export type State = ContainerState & {
	userAuth: UserAuth
}

export type Store = StoreBase<State>

export const defaultState: State = {
	page: { name: 'NotFound' },
	status: ContainerStatus.Running,

	data: {},
	userAuth: { status: 'unauthenticated' },
}

export const storeCreate = () => storeCreateBase<State>(defaultState)
